import { RowRechargerTransactionDto } from "@/dtos";
import { RechargerTransaction } from "@/entities";
import { getRechargerTransactionStatusLabel } from "@/helpers/options";
import { formatToCurrency, parseToLocalDateTimeFromUtc } from "@/helpers/utilities";

export const formatRowRechargerTransactionDto = (rechargerTransactions: RechargerTransaction[]): RowRechargerTransactionDto[] => {
    return rechargerTransactions.map(x => {
        const row: RowRechargerTransactionDto = {
            ...x,
            value_label: `$ ${formatToCurrency(x.value)}`,
            before_balance_payment_method_label: `$ ${formatToCurrency(x.before_balance_payment_method)}`,
            current_balance_payment_method_label: `$ ${formatToCurrency(x.current_balance_payment_method)}`,
            before_balance_recharger_label: `$ ${formatToCurrency(x.before_balance_recharger)}`,
            current_balance_recharger_label: `$ ${formatToCurrency(x.current_balance_recharger)}`,
            date_label: parseToLocalDateTimeFromUtc(x.date),
            status_label: getRechargerTransactionStatusLabel(x.status),
            recharger_label: x.recharger.name,
            payment_method_label: x.payment_method.identificative,
            is_reverse_label: x.is_reverse ? 'Si' : 'No',
            brand_label: x.payment_method?.brand?.name ?? 'S/N'
        }

        return row;
    });
}